<template>
    <section id="mainContainer">
        <userHeader></userHeader>

        <section class="mid-container">
            <!-- <div class="blog-list-slider" v-if="banners.length > 0">
                            <div class="blog-items" v-for="slider in banners" :key="slider.id">
                                <div class="blog-items--inner">
                                    <div class="blog-items--img">
                                        <img :src="getCdnImageAddress(slider.bannerImage, `w_1600,h_500/`)" alt="Banner image">
                                    </div>
                                   
                                </div>
                            </div>
                        </div> -->
            <section class="hero-section" v-if="banners.length > 0">
               
                   
                 
                        <div class="carousel-item"  v-for="slider in banners" :key="slider.id">
                            <img :src="getCdnImageAddress(slider.bannerImage, `w_1600,h_500/`)" alt="Banner image">
                            <div class="hero-slider-text">
                                <div class="h_s_t_in" v-html="slider.title"> </div>
                            </div>
                        </div>
                   
                
            </section>
            <section class="three-blocks-section">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-4" v-for="article in articles" :key="article.slug">
                            <div class="three_block__in">
                                <h3>{{getTruncatedText(article.title, 22)  }}</h3>
                                <div class="t_b_txt">
                                    {{ useStripHtml(getTruncatedText(article.description, 150)) }}
                                  
                                </div>
                                <div class="page_link">
                                    <router-link :to="`/article/${article.slug}`" id="readMoewLink">{{ constants['READ_MORE_LINK'] }}</router-link>
                                    <!-- <a href="article-detail.html">Read More</a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="four-block-section">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-3" v-for="(service, index) in services" :key="service.id">
                            <div class="four_block__in" :class="{ active: selectedServiceId === service.id }"
                                @click="showServiceDetails(service)">
                                <i><img :src="getCdnImageAddress(service.serviceIcon, `w_123,h_108/`)" alt="Strategy & Consulting" /></i>
                                <h4>{{getTruncatedText(service.title, 50)  }}</h4>
                                <div class="f_txt">
                                    {{ useStripHtml(getTruncatedText(service.shortDescription, 150)) }}
                                </div>
                                <div class="arrow-down-img"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="four-block-content" v-if="selectedService" style="display: block;">
                <div class="container clearfix b-f-left">
                    <!-- <button class="fold_close" @click="hideServiceDetails"><img
                            src="@/assets/images/flod-close-icon.png" alt="" /></button> -->
                    <div class="big-picture">
                        <img :src="getCdnImageAddress(selectedService.serviceImage, `w_563,h_457/`)" :alt="selectedService.title" />
                        <!-- <img src="@/assets/images/big-img-2.jpg" alt="" /> -->
                    </div>
                    <div class="picture-content showcontent">
                        <h4>{{ selectedService.title }}</h4>
                        <div class="four-fold-txt-box">
                            <h5>
                                {{ useStripHtml(selectedService.shortDescription) }}
                            </h5>
                            <div class="b_p_txt">
                                {{ useStripHtml(truncatedDescription) }}
                            </div>
                        </div>


                        <div class="page_link" v-if="shouldShowReadMore">
                            <a href="javascript:void(0);" @click="toggleDescription" class="read-more-btn">
                                {{ isDescriptionExpanded ? '<< Read Less' : 'Read More >>' }}
                            </a>
                            <!-- <a href="#">Read More >></a> -->
                        </div>
                    </div>
                </div>
            </section>

            <!-- <section class="big-picture-fold" v-for="client in clients" :key="client.slug">
                <div class="container clearfix b-f-left">
                    <div class="big-picture">
                        <img :src="getCdnImageAddress(client.companyImage, `w_575,h_457/`)" alt="" />
                    </div>
                    <div class="picture-content">
                        <h4>{{ constants['OUR_FEATURED_CLIENT_TEXT'] }}</h4>
                        <div class="home-fold-txt-box">
                            <h5>
                                {{client.title}}
                            </h5>
                            <div class="b_p_txt">
                                {{ useStripHtml(getTruncatedText(client.description, 400)) }}
                            </div> 
                        </div>
                        <div class="page_link">
                            <router-link :to="`/client/${client.slug}`">{{ constants['READ_MORE_LINK'] }} >></router-link>
                            <!<a href="#">Read More >></a> -->
                        <!-- </div>
                    </div>
                </div>
            </section>  -->

            <section class="big-picture-fold" v-for ="blog in blogs" :key="blog.slug">
                <div class="container clearfix b-f-right">
                    <div class="big-picture">
                        <img :src="getCdnImageAddress(blog.blogImage, `w_575,h_457/`)" alt="" />
                    </div>
                    <div class="picture-content showcontent" id="readMoewaa">
                        <h4>{{ constants['FEATURED_BLOG_ARTICLE_TEXT'] }}</h4>
                        <div class="home-fold-txt-box">
                            <h5>
                               {{blog.title}}
                            </h5>
                            <div class="b_p_txt">
                                {{ useStripHtml(getBlogDescription(blog)) }}
                            </div>
                        </div>
                        <!-- <div class="page_link">
                            <a href="javascript:void(0);" id="readMoewa">Read More >></a>
                        </div> -->
                        <div class="page_link" v-if="shouldShowBlogReadMore(blog)">
                   <!-- {  <a href="javascript:void(0);" id="readMoewa" @click="toggleBlogDescription(blog.id)">
                       { isExpandedBlog(blog.id) ? '<< Read Less' : 'Read More >>' }} 
                       
                    </a>-->
                    <router-link :to="`/blogs/${blog.slug}`">{{ constants['READ_MORE_LINK'] }} >></router-link>
                </div>
                    </div>
                </div>
            </section>
        </section>
        <userFooter></userFooter>
    </section>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import userHeader from "@/components/userHeader.vue";
import axios from 'axios';
import userFooter from "@/components/userFooter.vue";
import constants from '@/utils/en-US-User.json';
import { environment } from '@/config/environment';
import { API_BASE_URL } from '@/config/api.config';
import 'slick-carousel';
import $ from 'jquery';

interface Service {
    id: number;
    serviceIcon: string;
    title: string;
    shortDescription: string;
    description: string;
    serviceImage: string;
}
interface Clients {
    id: number;
    title: string;
    description: string;
    companyImage: string;
    companyLogo: string;
    challenge: string;
    solution: string;
    result: string;
    status: string;
    slug: string;
}
interface Blog {
    id: number;
    title: string;
    description: string;
    blogImage: string;
    slug: string;
}

export default defineComponent({
    name: "HomePage",

    data() {
        return {
            constants,
            banners: [] as any,
            articles: [] as any,
            services: [] as Service[],
            clients: [] as Clients[],
            selectedService: null as Service | null,
            selectedServiceId: null as number | null,
            isDescriptionExpanded: false,
            blogs: [] as any,
            expandedBlogIds: new Set<number>()  

        }
    },
    components: {
        userHeader,
        userFooter
    },
    created() {
        this.fetchBanner();
        this.fetchArticles();
        this.fetchServices().then(() => {
        // Set the first service as default after services are fetched
        if (this.services.length > 0) {
            this.selectedService = this.services[0];
            this.selectedServiceId = this.services[0].id;
        }
        });
        this.fetchClients();
        this.fetchBlogs()
    },
    computed: {
        truncatedDescription(): string {
            if (!this.selectedService) return "";
            const fullDescription = this.selectedService.description;
            if (this.isDescriptionExpanded || fullDescription.length <= 480) {
                return fullDescription;
            }
            return `${fullDescription.slice(0, 480)}...`;
        },
        shouldShowReadMore(): boolean {
            return (
                this.selectedService !== null &&
                this.selectedService.description.length > 480
            );
        },
    },
    watch: {
        banners: {
            handler(newVal) {
                if (newVal.length > 0) {
                    this.$nextTick(() => {
                        this.initializeBlogSlider();
                    });
                }
            },
            deep: true
        },
    },
    methods: {
        async fetchBanner() {
            const response = await axios.get(`${API_BASE_URL}/banner/?status=1&selectedPage=HOME`)
            this.banners = response.data

        },
        async fetchArticles() {
            try {
                const response = await axios.get(`${API_BASE_URL}/article/?status=1&limit=3`);
                this.articles = response.data;
            } catch (error) {
                console.error('Error fetching articles:', error);
            }
        },
        async fetchServices() {
            try {
                const response = await axios.get(`${API_BASE_URL}/service/?status=1&selectedPage=HOME&limit=4`);
                this.services = response.data;
            } catch (error) {
                console.error('Error fetching services:', error);
            }
        },
        async fetchClients(){
            try {
                const response = await axios.get(`${API_BASE_URL}/client/?status=1&limit=1`);
                this.clients = response.data;
            } catch (error) {
                console.error('Error fetching clients:', error);
            }
        },
        async fetchBlogs(){
            try {
                const response = await axios.get(`${API_BASE_URL}/blog/?status=1&limit=1`);
                this.blogs = response.data;
            } catch (error) {
                console.error('Error fetching blogs:', error);
            }
        },
        showServiceDetails(service: Service) {
            this.selectedService = service;
            this.selectedServiceId = service.id;
            this.isDescriptionExpanded = false;
        },
        hideServiceDetails() {
            this.selectedService = null;
            this.selectedServiceId = null;
            this.isDescriptionExpanded = false;
        },
        toggleDescription() {
            this.isDescriptionExpanded = !this.isDescriptionExpanded;
        },
        getBlogDescription(blog: Blog): string {
            const fullDescription = blog.description;
            if (this.isExpandedBlog(blog.id) || fullDescription.length <= 500) {
                return fullDescription;
            }
            return `${fullDescription.slice(0, 500)}...`;
        },

        shouldShowBlogReadMore(blog: Blog): boolean {
            return blog.description.length > 500;
        },

        toggleBlogDescription(blogId: number) {
            if (this.expandedBlogIds.has(blogId)) {
                this.expandedBlogIds.delete(blogId);
            } else {
                this.expandedBlogIds.add(blogId);
            }
        },

        isExpandedBlog(blogId: number): boolean {
            return this.expandedBlogIds.has(blogId);
        },
        getTruncatedText(text: string, limit: number): string {
            if (text.length > limit) {
                return `${text.slice(0, limit)}...`;
            }
            return text;
        },
        getCdnImageAddress(src: string, size: string): string {
            if (!src) return '';
            let cdnUrl: string = environment.imageCdn.getHost;
            cdnUrl = cdnUrl.concat(size);
            return cdnUrl + encodeURIComponent(src);
        },
        useStripHtml(html : string) {
            let regex = /(<([^>]+)>)/ig;
            return html.replace(regex, "");
        },
        initializeBlogSlider() {
            if ($('.hero-section').length) {
                $('.hero-section').slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                     arrows: false,
                     autoplay: true,
                     autoplaySpeed: 2000,
                     speed: 1000, // 1-second transition duration for smoothness
                     cssEase: 'ease-in-out', // Smooth easing function
                     pauseOnHover: false, // Pause auto-play on hover
                    responsive: [
                        {
                            breakpoint: 567,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: true,
                                arrows: false,
                                autoplay: true,
                                autoplaySpeed: 2000,
                                speed: 1000, // 1-second transition duration for smoothness
                                cssEase: 'ease-in-out', // Smooth easing function
                                pauseOnHover: false, // Pause auto-play on hover
                            }
                        }
                    ]
                });
            }
        },
    }
});
</script>